// extracted by mini-css-extract-plugin
export default {"dashboardContainer":"DashboardPage_dashboardContainer__svK-P","welcomeText":"DashboardPage_welcomeText__NWo5e","fadeInDown":"DashboardPage_fadeInDown__LcWVO"};